/** Fixed shell tabs on partner detail. */
export const PARTNER_SHELL_TABS = ['users', 'keys', 'audit'];

const LEGACY_INNER_TAB = {
  outbox: 'outbox',
  decisions: 'decisions',
  activity: 'activity',
  preview: 'preview',
  'pa-outbox': 'outbox',
  'pa-decisions': 'decisions',
  'pa-preview': 'preview',
  'pa-activity': 'activity',
};

/**
 * Resolve outer tab + PA Agent subtab from location search.
 * @returns {{ outer: string, subtab: string|null }}
 */
export function resolvePartnerDetailTabFromSearch(search = '') {
  const sp = new URLSearchParams(search);
  const tab = sp.get('tab');
  const subtab = sp.get('subtab');

  if (PARTNER_SHELL_TABS.includes(tab)) {
    return { outer: tab, subtab: null };
  }

  if (tab && tab !== 'pa-agent') {
    const inner = LEGACY_INNER_TAB[tab];
    if (inner) return { outer: 'pa-agent', subtab: subtab || inner };
  }

  if (tab === 'pa-agent') {
    return { outer: 'pa-agent', subtab: subtab || LEGACY_INNER_TAB[subtab] || 'activity' };
  }

  const cid = sp.get('correlation_id');
  const checkinId = sp.get('checkin_id');
  const q = sp.get('q');
  if (cid || checkinId || q) return { outer: 'pa-agent', subtab: 'activity' };

  return { outer: 'users', subtab: null };
}

export function paAgentDecisionsFiltersFromSearch(search = '') {
  const sp = new URLSearchParams(search);
  const cid = sp.get('correlation_id');
  const checkinId = sp.get('checkin_id');
  const q = sp.get('q');
  if (!cid && !checkinId && !q) return null;
  return { correlation_id: cid || '', checkin_id: checkinId || '', q: q || '', _seq: Date.now() };
}
